import React, { FC } from 'react';
import { Spin as AntdSpin } from 'antd';
import { SpinProps } from 'antd/lib/spin';

export const Spin: FC<SpinProps> = (props) => {
  return <AntdSpin {...props} />;
};
export default Spin;
